<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable persistent :overlay="false" max-width="800px" transition="dialog-transition">
      <v-card width="800px">
        <v-toolbar color="blue white--text darken-3" flat>
          <v-toolbar-title>Datos de Factura Electronica....</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="pt-0"> 
          <v-row no-gutters class="mb-3 text-center green lighten-5">
            <v-col>
              <small>
                <b>Sucursal: </b> <span> {{ factura.codigoSucursal }} </span>
              </small>
            </v-col>
            <v-col>
              <small>
                <b>P. Venta: </b> <span> {{ factura.codigoPuntoVenta }} </span>
              </small>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="7">
              <v-combobox
                v-model="filtroestudiante"
                :items="clientes"
                :loading="isloadingestudent"
                label="* Cliente"
                class="mr-2"
                loader-height="4"
                prepend-inner-icon="mdi-account"
                placeholder="tecla enter para buscar..."
                return-object
                hide-details
                outlined
              ></v-combobox>
            </v-col>
            <v-col cols="5" class="text-center">
              <small class="blue--text">Si no hay cliente, puede registrarlo:</small>
              <v-btn class="orange darken-2" tile dark @click="$refs.clientereg.openmodal()">
                <v-icon class="mx-1">mdi-content-save</v-icon> Registrar nuevo cliente
              </v-btn>
            </v-col>

            <v-col cols="7">
              <v-text-field
                v-model.trim="factura.email"
                label="Correo para enviar la factura:"
                :readonly="!filtroestudiante"
                prepend-inner-icon="mdi-email"
                type="text"
                class="mt-2 mr-2"
                outlined
                hide-details
                dense
                flat
              />
            </v-col>
            <v-col cols="5">
              <v-select
                v-model="formapago"
                :items="formas_pago"
                :loading="loadingformas"
                label="* Forma de pago:"
                item-text="nombre"
                prepend-inner-icon="mdi-cash-register"
                class="mt-2"
                return-object
                hide-details
                outlined
                dense
              ></v-select>
            </v-col>

            <v-col class="my-0 py-0" v-if="msgnitinvalido">
              <small class="mb-0 pb-0 ml-2 red--text"> <b>AVISO:</b> {{ msgnitinvalido }} </small>
            </v-col>

            <v-col cols="12" v-if="is567(eventoSigActivo)">
              <div>
                <v-divider class="mb-0 pb-0"></v-divider>
                <v-radio-group v-model="factura.online" label="Tipo de emision:" class="mt-1" hide-details row>
                  <v-radio label="Normal" :value="true"></v-radio>
                  <v-radio label="Regularizacion" :value="false"></v-radio>
                </v-radio-group>
              </div>
            </v-col>

            <v-col cols="12" class="px-2" v-if="is567(eventoSigActivo) && !factura.online">
              <p class="mb-0 mt-2">
                <small class="green--text"><span> El Ev. significativo requiere los siguientes datos: </span></small>
              </p>
              <v-row no-gutters>
                <v-col cols="5">
                  <v-text-field
                    v-model.number="factura.numeroFactura"
                    label="* Nro. factura"
                    class="mr-2 mt-0"
                    type="number"
                    outlined
                    hide-details
                    dense
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="fecha_factura"
                    label="* Fecha"
                    type="date"
                    class="mr-2"
                    outlined
                    hide-details
                    :disabled="loadingVerifSig"
                    :loading="loadingVerifSig"
                    dense
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="hora_factura"
                    :disabled="loadingVerifSig"
                    :loading="loadingVerifSig"
                    label="* Hora"
                    type="time"
                    outlined
                    hide-details
                    dense
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-divider class="mb-1"></v-divider>

          <v-row>
            <v-col cols="8">
              <v-combobox
                v-model="seleccionado"
                :items="conceptos"
                label="* Concepto de pago"
                :loading="loadingconceptos"
                :disabled="loadingconceptos"
                loader-height="4"
                placeholder="tecla enter para buscar..."
                prepend-inner-icon="mdi-cart"
                return-object
                hide-details
                outlined
                dense
              ></v-combobox>
            </v-col>
            <v-col cols="4">
              <v-btn
                :disabled="seleccionado == null || additem"
                class="green darken-2"
                tile
                dark
                @click="agregarcarrito()"
              >
                <v-icon class="mx-1">mdi-plus</v-icon> Agregar Item
              </v-btn>
            </v-col>
          </v-row>
          <v-checkbox
            v-model="isSendCorreo"
            label="Enviar correo automaticamente."
            class="ma-0 pa-0"
            dense
            hide-details
          />
          <v-progress-linear indeterminate class="green mb-0 pb-0" v-if="additem" />
          <v-divider class="mb-0 green"></v-divider>

          <p class="mb-0 pl-2 black--text green mt-0 lighten-5"><b>Detalle de los items:</b></p>
          <v-data-table
            :headers="headers"
            :items="factura.detalleVenta"
            hide-default-footer
            disable-pagination
            dense
            class="elevation-0"
          >
            <template v-slot:[`item.cantidad`]="{ item }">
              <v-text-field
                v-model.number="item.cantidad"
                type="number"
                @input="itemupdate(item)"
                outlined
                dense
                hide-details
              ></v-text-field>
            </template>
            <template v-slot:[`item.options`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small tile icon color="red" dark v-bind="attrs" v-on="on">
                    <v-icon small @click="deleteitem(item)">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </template>
                <span>Quitar Item</span>
              </v-tooltip>
            </template>
          </v-data-table>

          <v-row>
            <v-col class="text-right">
              Total: <b>{{ xtotal }}</b>
            </v-col>
          </v-row>

          <p class="mb-0">
            <b>Evento Significativo:</b> {{ eventoSigActivo ? 'SI' : 'NO' }}
            <v-progress-linear indeterminate v-if="loadingVerifSig" height="1" />
          </p>
          <div v-if="eventoSigActivo">
            <p class="mb-0 ml-4">
              <small><b>Desc:</b> [{{ eventoSigActivo.codigo }}] {{ eventoSigActivo.descripcion }}</small>
            </p>
          </div>
          <p class="mb-0">
            <b>Evento Masivo:</b> {{ isMasivoEvento ? 'SI' : 'NO' }}
            <v-progress-linear indeterminate v-if="loadingVerifMasivo" height="1" />
          </p>

          <v-progress-linear indeterminate v-if="loading" />
          <v-progress-linear indeterminate v-if="loadingVerifMasivo || loadingVerifSig || loadingonline" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-divider class="my-0"></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="ma-2"
            color="success"
            :disabled="loadingVerifMasivo || loadingVerifSig || loadingonline || loading"
            tile
            @click="save()"
          >
            <v-icon class="mx-1">mdi-content-save</v-icon> Generar Factura
          </v-btn>
          <v-btn color="blue darken-1" outlined tile @click="dialog = !dialog">
            Cancelar <v-icon> mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>

      <ClienteReg ref="clientereg" v-on:newregcliente="onnewregcliente" />
    </v-dialog>
  </v-row>
</template>

<script>
  import { getAccessToken } from '@/accessToken';
  import ClienteReg from '@/views/recibos/clientes/registrar.vue';
  import xaxios from '@/xaxios';
  import axios from 'axios';
  
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        xisOnline: true,
        loadingonline: false,
        loadingconceptos: false,
        loadingVerifSig: false,
        loadingVerifMasivo: false,
        eventoSigActivo: null,
        isMasivoEvento: false,
        msgnitinvalido: '',
        additem: false,
        filtroestudiante: '',
        msg: '',
        xtotal: 0,
        timeoutHnd: 0,
        loadingformas: false,
        isloadingestudent: false,
        loadingcodigoMetodoPago: false,
        seleccionado: null,
        formapago: null,
        xsucursal: null,
        clientes: [],
        conceptos: [],
        formas_pago: [],
        fecha_factura: null,
        hora_factura: null,
        isSendCorreo: true,

        factura: {
          cafc: null, //vacio
          online: true,
          codigoDocumentoSector: 1, // 11
          codigoExcepcion: 0, // 0
          codigoMetodoPago: 0, // forma_pago_id(efectivo, transferencia) consultar el endpoint: http://localhost:8090/api/v1/esam/formaspagos/{id}
          codigoMoneda: 1, // 1 bolivianos
          descuentoAdicional: 0, // 0 por defecto
          detalleVenta: [
            {
              actividadEconomica: 'string', // por defecto 853000
              cantidad: 0, // 1 por defecto
              codigo: 'string', // consultar al endpoint mandar conceto_id: http://localhost:8090/api/v1/esam/conceptospagos/{id}
              codigoDocumentoSector: 'string', // 11
              codigoSin: '', // consultar al endpoint mandar conceto_id: http://localhost:8090/api/v1/esam/conceptospagos/{id}
              codigoUnidad: 'string', // consultar al endpoint mandar conceto_id: http://localhost:8090/api/v1/esam/conceptospagos/{id}
              descripcion: 'string', // consultar al endpoint mandar conceto_id: http://localhost:8090/api/v1/esam/conceptospagos/{id}
              montoDescuento: 0, // 0
              numeroImei: 0,
              numeroSerie: 0,
              precio: 0, // monto recibo
              subTotal: 0, // cantidad * precio
            },
          ],
          email: '', // por el usuario
          codigoPuntoVenta: null, // 0 por defecto
          codigoSucursal: 0, // nro_sucursal, enviar codigosucursal al endpoint: http://localhost:8090/api/v1/esam/sucursales/{id}
          leyenda:
            'Ley Nro. 453: Esta prohibido importar, distribuir o comercializar productos expirados o prontos a expirar.',
          montoGiftCard: 0, // 0
          montoSujetoIva: 0, // por defecto monto total que se paga
          montoTotal: 0,
          montoTotalMoneda: 0, // por defecto monto total que se paga
          nombreEstudiante: 'string',
          numeroDocumentoCliente: '',
          numeroFactura: null,
          fechaHora: null,
          numeroTarjeta: 0, // 0 por defecto
          periodoFacturado: 'string', // fecha_prevista de pago del primer cuotas
          tipoCambio: 1, // 1 por defecto
          tipoEmision: 1, // 1 por defecto
          tipoFactura: 1, // 1 por defecto
          usuario: 'string', // el logueado
          // nuevo
          cliente: {
            complemento: 'string',
            estado: 1,
            id: 0,
            numeroDocumento: 'string',
            razonSocial: 'string',
            tipoDocumento: 'string',
          },
        },

        headers: [
          { text: 'Concepto', value: 'descripcion' },
          { text: 'Monto', value: 'precio', width: 120 },
          { text: 'Cantidad', value: 'cantidad', width: 120 },
          { text: 'Subtotal', value: 'subTotal', width: 120 },
          { text: '', value: 'options', width: 30 },
        ],
        //desserts: [],
        apikeytoken: null,
      };
    },
    components: { ClienteReg },
    watch: {
      filtroestudiante: function() {
        if (typeof this.filtroestudiante != 'string') {
          //window.console.log('filtroestudiante:', this.filtroestudiante);
          if (!this.filtroestudiante) return;
          this.factura.numeroDocumentoCliente = this.filtroestudiante.numero_documento;
          this.factura.email = this.filtroestudiante.email;
          this.factura.cliente.complemento = this.filtroestudiante.complemento;
          this.factura.cliente.id = this.filtroestudiante.id;
          this.factura.cliente.numeroDocumento = this.filtroestudiante.numero_documento;
          this.factura.cliente.razonSocial = this.filtroestudiante.razon_social;
          //this.factura.cliente.tipoDocumento = this.filtroestudiante.tipo_documento_id;
          this.factura.cliente.tipoDocumento = this.filtroestudiante.tipo_documento.codigo_clasificador_SIN;
          this.factura.nombreEstudiante = this.filtroestudiante.razon_social;
          if (this.filtroestudiante.is_verificado) this.factura.codigoExcepcion = 0;
          else this.factura.codigoExcepcion = 1;

          let numd = this.factura.cliente.numeroDocumento;
          let defecto = numd == '99001' || numd == '99002' || numd == '99003';
          if (defecto) {
            this.msgnitinvalido = `Casos especiales normas impuestos.`;
          } else if (!this.filtroestudiante.is_verificado && this.filtroestudiante.tipo_documento_id == 2) {
            this.msgnitinvalido = `El NIT (${this.filtroestudiante.numero_documento}) no esta verificado`;
          } else this.msgnitinvalido = '';

          //window.console.log(JSON.stringify(this.factura, null, 4));
          return;
        }
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var vue = this;
        this.timeoutHnd = setTimeout(function() {
          if (vue.filtroestudiante && vue.filtroestudiante.length > 2) {
            vue.getclientes();
          } else {
            vue.msg = '';
          }
          this.timeoutHnd = 0;
        }, 500);
      },
      formapago: function() {
        if (!this.formapago) return;
        this.factura.codigoMetodoPago = this.formapago.codigo_clasificador_SIN;
      },
      fecha_factura: function() {
        if (!this.fecha_factura) return;
        this.parseFechaHora();
      },
      hora_factura: function() {
        if (!this.hora_factura) return;
        this.parseFechaHora();
      },
      'factura.online': function() {
        if (!this.factura.online) {
          this.factura.numeroFactura = null;
          this.factura.fechaHora = null;
          this.fecha_factura = null;
          this.hora_factura = null;
        }
      },
    },
    methods: {
      async showThisView(sucursal) {
        window.console.log('token factira>>',sucursal.xnit);
        await this.obtenerToknFactura(sucursal.sucursal_id);
        this.dialog = true;
        this.msg = '';
        this.xsucursal = sucursal;
        this.factura.cafc = null;
        this.eventoSigActivo = null;
        this.isMasivoEvento = false;
        this.msgnitinvalido = '';
        // window.console.log(sucursal);
        this.factura.codigoPuntoVenta = sucursal.punto_venta.codigo_punto_venta;
        this.factura.codigoSucursal = sucursal.sucursal.numero_sucursal;
        this.factura.detalleVenta = [];
        this.factura.codigoExcepcion = 0;
        //this.desserts = [];
        this.factura.montoTotal = 0;
        this.factura.montoSujetoIva = 0;
        this.factura.montoTotalMoneda = 0;
        this.factura.codigoMetodoPago = 0;
        this.factura.numeroFactura = null;
        this.factura.online = true;
        this.xisOnline = true;
        this.factura.email = '';
        this.filtroestudiante = '';
        this.factura.cliente.razonSocial = '';
        this.formapago = null;
        let user = this.$store.state.DATA_USER;
        if (!user.seg_apellido) user.seg_apellido = '';
        this.factura.usuario = `${user.nombres} ${user.pri_apellido} ${user.seg_apellido}`;
        this.getconceptos();
        this.getFormasdePago();
        // this.getLeyendas(this.factura.codigoDocumentoSector);
        this.verificarIfExistMasivo(sucursal.punto_venta.codigo_punto_venta, sucursal.sucursal.numero_sucursal);
        this.verificarIfExistSig(
          this.factura.codigoDocumentoSector,
          sucursal.punto_venta.codigo_punto_venta,
          sucursal.sucursal.numero_sucursal,
        );
        this.verificarOnline();
      },
      getclientes() {
        const vue = this;
        vue.isloadingestudent = true;
        let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/clientes?numero_documento=${this.filtroestudiante}&razon_social=${this.filtroestudiante}`;

        xaxios
          .get(url)
          .then(function(response) {
            let data = response.data.data;
            data.map((x) => {
              x.text = `${x.razon_social} (${x.numero_documento})`;
            });
            vue.clientes = data;
            vue.isloadingestudent = false;
          })
          .catch(function(error) {
            vue.isloadingestudent = false;
            window.console.log(error);
          });
      },
      getconceptos() {
        let vue = this;
        vue.loadingconceptos = true;
        const unidad = this.$store.state.CARGO.sede.unidad_negocio;
        // let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptospagos`;
        // let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptopagounidadnegocio/conceptopago/{CONCEPTOID:[1-9][0-9]{0,8}}/unidadnegocio/{UNIDADNEGOCIOID:[1-9][0-9]{0,8}}/nit/{NITID:[1-9][0-9]{0,8}}`;
        let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptopagounidadnegocio/unidadnegocio/${unidad}/nit/${this.xsucursal.xnit.id}`;

        xaxios
          .get(url)
          .then(function(response) {
            let data = response.data.data; 
            data.map((c) => {
              if(c){
                c.text = `[${c.concepto_pago.monto}bs] ${c.concepto_pago.nombre} (${c.concepto_pago.descripcion})`;
              }
            });
            vue.conceptos = data;
            vue.loadingconceptos = false; 
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingconceptos = false;
          });
      },
      agregarcarrito() {
        this.msg = '';
        if (!this.seleccionado) return;
        //window.console.log('this.seleccionado>>', this.seleccionado, this.factura.detalleVenta);
        let existe = this.factura.detalleVenta.find((x) => x.codigo == this.seleccionado.id);
        if (existe) {
          this.msg = 'Ya existe el item en el detalle.';
          return;
        }
        let cp = window.Object.assign({}, this.seleccionado);
        cp.cantidad = 1;
        cp.subtotal = cp.monto * cp.cantidad;

        let incluye = (cp.subtotal + '').includes('.');
        let termina = (cp.subtotal + '').endsWith('.');
        if (incluye && !termina) cp.subtotal = Math.round((cp.subtotal + Number.EPSILON) * 100) / 100;

        this.additem = true;
        this.getconceptopago(cp);
      },
      onnewregcliente(nuevo) {
        window.console.log('>>>>>> ', nuevo);
      },
      updatetotal() {
        let xt = 0;
        /*this.desserts.forEach((x) => {
          xt += x.subtotal;
        });*/
        this.factura.detalleVenta.forEach((x) => {
          let incluye = (x.subTotal + '').includes('.');
          let termina = (x.subTotal + '').endsWith('.');
          if (incluye && !termina) x.subTotal = Math.round((x.subTotal + Number.EPSILON) * 100) / 100;

          xt += x.subTotal;
        });

        let incluye = (xt + '').includes('.');
        let termina = (xt + '').endsWith('.');
        if (incluye && !termina) xt = Math.round((xt + Number.EPSILON) * 100) / 100;

        this.xtotal = xt;
        this.factura.montoTotal = xt;
        this.factura.montoSujetoIva = xt;
        this.factura.montoTotalMoneda = xt;
      },
      getconceptopago(item) {
        let vue = this;  
        window.console.log('statusconceptos::', item);
        let detalle = {};
        detalle.actividadEconomica = '' + item.actividad_economica_sin;
        detalle.codigoDocumentoSector = ""+item.codigo_documento_sector;
        detalle.cantidad = 1;
        detalle.codigo = ""+item.concepto_pago.id;  
        detalle.codigoSin = ''+item.codigo_sin;
        detalle.codigoUnidad = ''+item.concepto_pago.unidad_medida.codigo_SIN;
        detalle.unidadMedida = item.concepto_pago.unidad_medida.id; 
        detalle.descripcion = item.concepto_pago.descripcion;
        detalle.montoDescuento = 0;
        detalle.numeroImei = 0;
        detalle.numeroSerie = 0;
        detalle.precio = item.concepto_pago.monto;
        detalle.subTotal = item.concepto_pago.monto;
        detalle.unidadDescripcion = item.concepto_pago.unidad_medida.descripcion_SIN;

        if (!detalle.codigoSin) {
          vue.msg = `Falta el codigo SIN del concepto: ${item.descripcion}`;
          window.console.log('msggg', detalle.codigoSin);
        } else {
          window.console.log('itemitem', detalle);
          vue.factura.detalleVenta.push(detalle);
          vue.updatetotal();
        }
        vue.additem = false;
      },
      getconceptopagobk(item) {
        let vue = this;
        const unidad = this.$store.state.CARGO.sede.unidad_negocio;
        // let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptospagos/${item.id}`;
        let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptopagounidadnegocio/conceptopago/${item.id}/unidadnegocio/${unidad}/nit/${this.xsucursal.xnit.id}`;

        xaxios
          .get(url)
          .then(function(response) {
            let data = response.data;
            window.console.log('statusconceptos::', data);
            let detalle = {};
            //detalle.actividadEconomica = '620200';
            //detalle.codigoDocumentoSector = '1';
            detalle.actividadEconomica = '' + item.codigo_actividad;
            detalle.codigoDocumentoSector = ""+item.codigo_documento_sector;
            detalle.cantidad = item.cantidad;
            detalle.codigo = ""+data.id; 
            detalle.unidadMedida = data.unidad_medida.id; 
            detalle.codigoSin = '';
            if( data.codigo_sin ) detalle.codigoSin = data.codigo_sin;
            else if(item.unidad_medida) detalle.codigoSin = '' + item.unidad_medida.codigo_SIN;
            if(item.unidad_medida) detalle.codigoUnidad = '' + item.unidad_medida.codigo_SIN;
            else detalle.codigoUnidad = 'No hay :(';
            detalle.descripcion = item.descripcion;
            detalle.montoDescuento = 0;
            detalle.numeroImei = 0;
            detalle.numeroSerie = 0;
            detalle.precio = item.monto;
            detalle.subTotal = item.subtotal;
            detalle.unidadDescripcion = data.unidad_medida.descripcion_SIN;
            //detalle.id = data.id; // no va pero lo necesito
            // if (!data.codigo_sin) {
            if (!detalle.codigoSin) {
              vue.msg = `Falta el codigo SIN del concepto: ${item.descripcion}`;
              window.console.log('msggg', detalle.codigoSin);
            } else {
              //vue.desserts.push(item);
              window.console.log('itemitem', detalle);
              vue.factura.detalleVenta.push(detalle);
              vue.updatetotal();
            }
            vue.additem = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.additem = false;
          });
      },
      getFormasdePago() {
        let vue = this;
        vue.loadingformas = true;
        let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/formaspagos`;

        xaxios
          .get(url)
          .then(function(response) {
            let data = response.data.data;
            window.console.log('>FORMAS', data);
            vue.formas_pago = data;
            vue.loadingformas = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingformas = false;
          });
      },
      verificarIfExistMasivo(codPunto, codSucursal) {
        window.console.log('verificarIfExistMasivo', codPunto, codSucursal);
        let vue = this;
        vue.loadingVerifMasivo = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/eventomasivo/existeActivo/sucursal/${codSucursal}/puntoventa/${codPunto}`,
          headers: {
            apikey: this.$store.getters.getApiKey,
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('verificarIfExistMasivo:', data);
            vue.isMasivoEvento = data.isExiste;
            vue.loadingVerifMasivo = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingVerifMasivo = false;
            let data = error.response.data;
            let mensaje = data.mensaje;
            window.console.log(data);
            if (mensaje || data.detalles) vue.msg = `Error ${mensaje}`;
            else vue.msg = `${data[0].codigo} - ${data[0].descripcion}`;
          });
      },
      verificarIfExistSig(numeroDocumentoSector, codPunto, codSucursal) {
        window.console.log('verificarIfExistSig', codPunto, codSucursal);
        this.loadingVerifSig = true;
        this.eventoSigActivo = null;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/eventosignificativo/existeActivo/sucursal/${codSucursal}/puntoventa/${codPunto}`,
          headers: {
            apikey: this.$store.getters.getApiKey,
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('verificarIfExistSig:', data);
            vue.eventoSigActivo = data;
            vue.loadingVerifSig = false;
            vue.verificarCafcActivo(numeroDocumentoSector);
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingVerifSig = false;
            let data = error.response.data;
            window.console.log(data);
            //let mensaje = data.mensaje;
            /*if (mensaje || data.detalles) vue.msg = `${mensaje}`;
            else vue.msg = `${data[0].codigo} - ${data[0].descripcion}`;*/
          });
      },
      verificarCafcActivo(numeroDocumentoSector) {
        let vue = this;
        this.loadingVerifSig = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/cafcs/buscarActivo/${numeroDocumentoSector}`,
          headers: {
            apikey: this.$store.getters.getApiKey,
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('verificarCafcActivo:', data);
            if (!vue.is567(vue.eventoSigActivo)) {
              vue.factura.cafc = null;
            } else {
              vue.factura.cafc = data.codigo;
            }
            vue.loadingVerifSig = false;
          })
          .catch(function(error) {
            window.console.log(error.response.data.mensaje);
            vue.loadingVerifSig = false;
          });
      },
      parseFechaHora() {
        // 2022-05-31T17:34:32.597
        //if(!this.eventoSigActivo) return;
        window.console.log('>>>', this.eventoSigActivo);
        let fechita = `${this.fecha_factura}T${this.hora_factura}:00.000`;
        let evfecha = new Date(this.eventoSigActivo.fecha_inicio);
        let evfechafin = new Date(this.eventoSigActivo.fecha_fin);
        let fafecha = new Date(fechita);
        this.factura.fechaHora = fechita;
        if (fafecha.getTime() <= evfecha.getTime()) {
          this.msg = 'Fecha de factura no puede ser menor a la fecha de inicio del evento significativo.';
        } else if (fafecha.getTime() > evfechafin.getTime()) {
          this.msg = 'Fecha de factura no puede ser mayor a la fecha fin del evento significativo.';
        } else {
          this.msg = '';
        }
        //window.console.log('>>>', fechita, this.eventoSigActivo.fecha_inicio, '\n', evfecha, fafecha);
      },
      deleteitem(item) {
        /*this.desserts = this.desserts.filter((x) => {
          return x.id != item.id;
        });*/
        this.factura.detalleVenta = this.factura.detalleVenta.filter((x) => {
          return x.codigo != item.codigo;
        });
        this.updatetotal();
      },
      itemupdate(item) {
        window.console.log('update:::', item);
        item.subTotal = item.cantidad * item.precio;
        this.updatetotal();
      },
      getLeyendas(docsector) {
        //let docsector = 11;
        let sector = '';
        if (docsector == 1) sector = '620200';
        else if (docsector == 11) sector = '853000';
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/catalogo/leyenda`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            let filtrados = data.filter((x) => {
              return x.codigo.startsWith(sector);
            });
            let min = 0;
            let max = filtrados.length - 1;
            let random = Math.floor(Math.random() * (max - min + 1) + min);
            vue.factura.leyenda = filtrados[random].descripcion;
          })
          .catch(function(error) {
            window.console.log(error);
          });
      },
      is567(evento) {
        if (!evento) return false;
        let code = evento.codigo;
        if (code == '5' || code == '6' || code == '7') return true;
        return false;
      },
      verificarOnline() {
        this.loadingonline = true;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/empresas/isonline`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('verificarOnline', data);
            if (data) {
              vue.xisOnline = data.isOnline;
            }
            vue.loadingonline = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingonline = false;
          });
      },
      save() {
        window.console.log(JSON.stringify(this.factura, null, 4));
        this.msg = '';
        if (!this.factura.cliente.razonSocial) this.msg = 'No hay cliente, debe seleccionar o registrar uno.';
        if (!this.factura.codigoMetodoPago) this.msg = 'Seleccione una forma de pago.';
        if (this.factura.detalleVenta.length == 0) this.msg = 'Agregue los items para generar la factura';
        if (this.eventoSigActivo && this.is567(this.eventoSigActivo) && !this.factura.online) {
          if (!this.factura.numeroFactura) this.msg = 'El ev. Significativo solicita un numero de factura valido.';
          //if (!this.factura.online) this.msg = 'Debe especificar el tipo de facturacion.';
          if (!this.fecha_factura) this.msg = 'El ev. Significativo solicita fecha y hora validos.';
          if (!this.hora_factura) this.msg = 'El ev. Significativo solicita fecha y hora validos.';
          let evfecha = new Date(this.eventoSigActivo.fecha_inicio);
          let evfechafin = new Date(this.eventoSigActivo.fecha_fin);
          let fafecha = new Date(this.factura.fechaHora);
          if (fafecha.getTime() <= evfecha.getTime()) {
            this.msg = 'Fecha de factura no puede ser menor a la fecha de inicio del evento significativo.';
          } else if (fafecha.getTime() > evfechafin.getTime()) {
            this.msg = 'Fecha de factura no puede ser mayor a la fecha fin del evento significativo.';
          }
        }
        if (this.msg) return;
        // if (!this.xisOnline) this.factura.online = false;
        if (this.factura.online) {
          this.factura.cafc = null;
        }
        //if( !this.xisOnline && this.factura.cliente.tipoDocumento == 5 ) {
        if (this.factura.cliente.tipoDocumento != 5) {
          this.factura.codigoExcepcion = 0;
        }
        let numd = this.factura.cliente.numeroDocumento;
        let defecto = numd == '99001' || numd == '99002' || numd == '99003';
        if (defecto) {
          this.factura.codigoExcepcion = 0;
        }

        if (this.isSendCorreo) this.factura.enviarCorreo = true;
        else this.factura.enviarCorreo = false;

        this.loading = true;
        window.console.log('datos enviados: ', JSON.stringify(this.factura, null, 4));
        //let url = `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/cliente`;
        // let url = `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/sectorCompraVenta/cliente`; 
        let url = `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/sectorCompraVenta/cliente`; 
        if (this.isMasivoEvento) url = `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/masivo/cliente`;
        let vue = this;
        var config = {
          method: 'post',
          url: url,
          headers: {
            'Content-Type': 'application/json',
            // apikey: this.xsucursal.sucursal.nro_nit,
            apikey: this.apikeytoken,
          },
          data: this.factura,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('emitirfactura>>>>: ', data);
            vue.loading = false;
            if (data.venta) {
              vue.$emit('facturageneradax', data);
              vue.dialog = false;
            }
          })
          .catch(function(error) {
            vue.loading = false;
            let data = error.response.data;
            let mensaje = data.mensaje;
            window.console.log(data);
            if(data && data.data) vue.msg = data.data.error;
            else if (mensaje || data.detalles) vue.msg = `Error ${mensaje}`;
            else vue.msg = `${data[0].codigo} - ${data[0].descripcion}`;
          });
      },

      async obtenerToknFactura(idsuc) {
        let tok = getAccessToken();
        const apiAxios = axios.create({
          baseURL: '',
          headers: {
            'Content-Type': 'application/json',
            Authorization: tok,
          },
        });
        this.apikeytoken = await apiAxios
          .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${idsuc}`)
          .then(({ data }) => (data.apikey ? data.apikey : ''));
      },
    },
    mounted() {},
  };
</script>

<style></style>
